import { isFunction } from '@aloft/toolkit-shared';
import { Flex, Typography } from '@aloft/toolkit-sui';

import { useCheckoutSteps } from './useCheckoutSteps.ts';

export function CheckoutStep({
  step,
  title,
  children,
}: {
  step: number;
  title: string;
  children: React.ReactNode | ((p: { isComplete: boolean }) => React.ReactNode);
}) {
  const { step: currentStep } = useCheckoutSteps();

  if (currentStep < step) return null;

  const isComplete = currentStep > step;

  return (
    <Flex flexDirection="column" gap="12px">
      <Typography variant="h3">{title}</Typography>
      {isFunction(children) ? children({ isComplete }) : children}
    </Flex>
  );
}
